import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../api/axios';

const DISPLAY_PRICE = { 10: 0, 11: 17000 };

export default function Spesial17Form() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialPaket = searchParams.get('paket') || '11';

  const [kelasId, setKelasId] = useState(initialPaket);
  const [kelas, setKelas] = useState([]);
  const [loading, setLoading] = useState(true);
  const member = JSON.parse(localStorage.getItem('member_user') || 'null');
  const isLoggedIn = !!member;
  const [formData, setFormData] = useState({ nama: member?.name || '', hp: member?.phone || '' });
  const [accountExists, setAccountExists] = useState(null);

  useEffect(() => {
    api.get('/api/webinars').then(r=>setKelas(r.data)).catch(()=>{}).finally(()=>setLoading(false));
  }, []);

  const handleChange = e => {
    let v = e.target.value;
    if (e.target.name === 'hp') v = v.replace(/[^0-9]/g,'');
    setFormData({ ...formData, [e.target.name]: v });
  };
  const normalizePhone = p => { p=p.replace(/[^0-9]/g,''); if(p.startsWith('0')) p='62'+p.slice(1); else if(!p.startsWith('62')) p='62'+p; return p; };
  const validatePhone = p => /^628\d{7,13}$/.test(normalizePhone(p));
  const formatRupiah = n => new Intl.NumberFormat('id-ID',{style:'currency',currency:'IDR',minimumFractionDigits:0}).format(n);
  const selectedDisplayPrice = DISPLAY_PRICE[kelasId] || 0;

  const handleSubmit = async e => {
    e.preventDefault();
    const selectedKelas = kelas.find(w=>w.id==kelasId);
    if(!selectedKelas){ alert('Silakan pilih paket.'); return; }
    if(!isLoggedIn){
      if(!formData.nama.trim()){ alert('Nama wajib diisi.'); return; }
      if(!validatePhone(formData.hp)){ alert('Nomor HP format 08xxxxxxxxxx'); return; }
      try{ const r=await api.post('/api/member/check',{phone:normalizePhone(formData.hp)}); if(r.data?.exists){ setAccountExists(formData.hp); return; } }catch{}
    }
    const idtransaction='conexsee-'+Math.random().toString(36).substring(2,15);
    const storedHp=isLoggedIn?formData.hp:normalizePhone(formData.hp);
    const paymentData={ name:formData.nama, number:storedHp, status:'Umum', webinar_id:kelasId, transaction_id:idtransaction, member_id:isLoggedIn?member.id:null };
    try{
      await api.post('/api/webinar-payments', paymentData);
      navigate(`/webinar/redirect/${idtransaction}`,{ state:{ formData:{ nama:formData.nama, hp:storedHp, status:'Umum', kelas_id:kelasId, member_id:paymentData.member_id }, selectedWebinar:selectedKelas }});
    }catch(err){ console.error(err); alert('Gagal menyimpan data'); }
  };

  return (
    <div className="bg-light min-vh-100 py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-7">
            <Link to="/promo-merdeka" className="btn btn-outline-secondary btn-sm mb-3">← Kembali ke Paket</Link>
            <div className="card shadow">
              <div className="card-body p-4">
                <h4 className="fw-bold mb-1"><i className="bi bi-flag-fill me-2" style={{color:'#CE1126'}}></i>Form Pendaftaran</h4>
                <p className="text-muted mb-4">Lengkapi data untuk paket <strong>Independence Plus+</strong> (Rp 17.000).</p>
                {isLoggedIn && <div className="alert alert-info"><strong>Halo, {member.name}!</strong> Login sebagai {member.phone}.</div>}
                {!isLoggedIn && accountExists && <div className="alert alert-info text-center"><strong>Nomor {accountExists} sudah terdaftar.</strong><br/><Link to="/login" className="btn btn-dark btn-sm mt-2">Login di Sini</Link></div>}
                {((!isLoggedIn && !accountExists) || isLoggedIn) && (
                  <form onSubmit={handleSubmit}>
                    {!isLoggedIn && (
                      <div className="row mb-3">
                        <div className="col-md-6"><label className="form-label">Nama Lengkap</label><input name="nama" value={formData.nama} onChange={handleChange} className="form-control" placeholder="Nama lengkap" required /></div>
                        <div className="col-md-6"><label className="form-label">Nomor HP</label><input name="hp" value={formData.hp} onChange={handleChange} className="form-control" placeholder="081234567890" required /><div className="form-text">Format 08xxxxxxxxxx</div></div>
                      </div>
                    )}
                    <div className="row mb-3">
                      <div className="col-md-6"><label className="form-label">Pilih Kelas</label><select className="form-select" value={kelasId} onChange={e=>setKelasId(e.target.value)} required><option value="11">Independence Plus+ ({formatRupiah(17000)})</option><option value="10">Independence (GRATIS)</option></select></div>
                      <div className="col-md-6"><label className="form-label">Biaya</label><input className="form-control" value={selectedDisplayPrice?formatRupiah(selectedDisplayPrice):'-'} readOnly /></div>
                    </div>
                    <button type="submit" className="btn btn-warning w-100 fw-semibold">Daftar Sekarang — {formatRupiah(17000)}</button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
